import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5036f65a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-oc-coupon-detail"
}
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "section section-description" }
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = { class: "section section-description" }
const _hoisted_6 = { class: "section-title" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ~ ")
const _hoisted_8 = { class: "coupon-wrapper" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "tips-wrapper" }
const _hoisted_15 = { class: "operate-wrapper" }

import { onMounted, ref } from 'vue';
  import CardCoupon from '../components/card-coupon.vue';
  import { ICoupon, getCouponDefaultData } from '@/types/coupon';
  import { useI18n } from 'vue-i18n';
  import { request, confirm } from '@/utils';
  import { useRoute } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const coupon = ref<ICoupon>(getCouponDefaultData());

  const route = useRoute();
  onMounted(fetchdata);

  async function fetchdata() {
    const { data } = await request.get<ICoupon>(`/oc_coupon_records/${route.params.id}`);
    coupon.value = data;
  }

  async function handleMakeUse() {
    await confirm('', { content: t('make_this_coupon_used_confirm') });
    await request.post(`oc_coupon_records/${coupon.value.id}/use`);
    fetchdata();
  }

return (_ctx: any,_cache: any) => {
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!
  const _component_b_button = _resolveComponent("b-button")!

  return (coupon.value.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CardCoupon, { coupon: coupon.value }, null, 8, ["coupon"]),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('coupon_details')), 1),
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("h6", _hoisted_4, _toDisplayString(coupon.value.oc_coupon_template.name), 1),
          _createElementVNode("p", null, _toDisplayString(coupon.value.oc_coupon_template.description), 1)
        ]),
        _createElementVNode("section", _hoisted_5, [
          _createElementVNode("h6", _hoisted_6, _toDisplayString(_unref(t)('available_time')), 1),
          _createElementVNode("p", null, [
            _createVNode(_component_AppTimeFormat, {
              time: coupon.value.started_at,
              format: "YYYY-MM-DD"
            }, null, 8, ["time"]),
            _hoisted_7,
            _createVNode(_component_AppTimeFormat, {
              time: coupon.value.ended_at,
              format: "YYYY-MM-DD"
            }, null, 8, ["time"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass(["box-img", { used: coupon.value.used }])
          }, [
            (coupon.value.oc_coupon_template.coupon_type === 'image_coupon')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "image",
                  src: coupon.value.oc_coupon_template.coupon_image?.url
                }, null, 8, _hoisted_9))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (coupon.value.coupon_display_type === 'qrcode')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "qrcode",
                        src: coupon.value.qrcode?.url
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (coupon.value.coupon_display_type === 'barcode')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "barcode",
                        src: coupon.value.barcode?.url
                      }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ], 64)),
            _hoisted_12
          ], 2),
          (coupon.value.oc_coupon_template.coupon_type !== 'image_coupon')
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(coupon.value.coupon_code), 1))
            : _createCommentVNode("", true)
        ]),
        (coupon.value.oc_coupon_template.show_usage === true)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('tips')), 1),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_b_button, {
                  pill: "",
                  variant: "primary",
                  size: "lg",
                  style: {"width":"20rem"},
                  disabled: coupon.value.used === true,
                  onClick: handleMakeUse
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('make_this_coupon_used')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})